module.exports = __webpack_public_path__ + "img/KFH0346.d67d353f.png";